import Vue from 'vue'
import VueRouter from 'vue-router'
import home from '../views/home.vue'
import sobre from '../views/sobre.vue'
import aviso from '../views/Aviso.vue'
import ayuda from '../views/ayuda.vue'
import loan from '../views/loan.vue'
import complaints from '../views/complaints.vue'

import initialconfirm from '../views/internal/initialconfirm/index.vue'
import banca from '../views/internal/payment/banca.vue'
import calculation from '../views/internal/payment/calculation.vue'
import efectivo from '../views/internal/payment/efectivo.vue'
import payment from '../views/internal/payment/index.vue'
import nequi from '../views/internal/payment/nequi.vue'
import pse from '../views/internal/payment/pse.vue'
import rescheduleIndex from '../views/internal/payment/rescheduleIndex.vue'

Vue.use(VueRouter)

const routes = [
	{
		path: '/',
		redirect: '/home',
	},
	{
		path: '/home',
		name: 'home',
		component: home,
	},
	{
		path: '/about',
		name: 'about',
		component: sobre,
	},
	{
		path: '/notice',
		name: 'notice',
		component: aviso,
	},
	{
		path: '/help',
		name: 'help',
		component: ayuda,
	},
	{
		path: '/loan',
		name: 'loan',
		component: loan,
	},
	{
		path: '/complaints',
		name: 'complaints',
		component: complaints,
	},

	{
		path: '/initialconfirm',
		name: 'initialconfirm',
		component: initialconfirm,
	},
	{
		path: '/banca',
		name: 'banca',
		component: banca,
	},
	{
		path: '/calculation',
		name: 'calculation',
		component: calculation,
	},
	{
		path: '/efectivo',
		name: 'efectivo',
		component: efectivo,
	},
	{
		path: '/payment',
		name: 'payment',
		component: payment,
	},
	{
		path: '/nequi',
		name: 'nequi',
		component: nequi,
	},
	{
		path: '/pse',
		name: 'pse',
		component: pse,
	},
	{
		path: '/rescheduleIndex',
		name: 'rescheduleIndex',
		component: rescheduleIndex,
	},
]

const router = new VueRouter({
	mode: location.href.indexOf('//www.luckyplata.co') >= 0 ? 'history' : 'hash',
	base: process.env.BASE_URL,
	routes,
})

export default router
